/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { EnvironmentProviders, Provider } from '@angular/core';
import { NotificationsEffects, notificationsLocalStorageSyncReducer } from '@app/core/notification/ngrx';
import { notificationsReducers } from '@app/core/notification/ngrx/notifications.reducers';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

export const provideNotifications = (): (Provider | EnvironmentProviders)[] => [
  provideEffects(NotificationsEffects),
  provideState('notifications', notificationsReducers, {
    metaReducers: [notificationsLocalStorageSyncReducer],
  }),
];
